<template>
  <div class="remarks-cell" :class="{ changed: isChanged }">
    <div
      v-if="!isEditable"
      class="readonly-text"
      :class="{ noData: isNotData }"
    >
      {{ displayValue }}
    </div>
    <div v-else class="editor">
      <textarea
        class="textarea-input"
        rows="2"
        :value="inputValue"
        @input="handleInput"
        :placeholder="placeholder"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererRemarksInput",
  data() {
    return {
      inputValue:
        this.params &&
        this.params.value !== undefined &&
        this.params.value !== null
          ? this.params.value
          : "",
      placeholder: "備考を入力",
    };
  },
  computed: {
    isNotData() {
      const value = this.params ? this.params.value : null;
      return value === null || value === undefined || value === "";
    },
    isEditable() {
      const parent =
        this.params &&
        this.params.context &&
        this.params.context.componentParent
          ? this.params.context.componentParent
          : null;
      const data = this.params && this.params.data ? this.params.data : {};
      const isClosed = data.isClosed || false;
      return parent && parent.isEdit && !isClosed;
    },
    displayValue() {
      const value = this.params ? this.params.value : null;
      if (!value) {
        return "-";
      }
      return value;
    },
    isChanged() {
      if (!this.isEditable) return false;
      const parent =
        this.params &&
        this.params.context &&
        this.params.context.componentParent
          ? this.params.context.componentParent
          : null;
      if (!parent || !parent.originalTableRows || !this.params.data) {
        return false;
      }

      const currentRow = this.params.data;
      const originalRow = parent.originalTableRows.find(
        row => row.id === currentRow.id
      );
      if (!originalRow) return false;
      const currentVal = this.inputValue;
      const originalVal = originalRow.remarks;

      return currentVal !== originalVal;
    },
  },
  methods: {
    refresh(params) {
      this.params = params;
      const value =
        params.value === null || params.value === undefined ? "" : params.value;
      this.inputValue = this.isEditable ? value : "";
      return true;
    },
    handleInput(event) {
      const value = event.target.value;
      this.inputValue = value;
      this.params.node.setDataValue("remarks", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.remarks-cell {
  &.changed {
    .textarea-input {
      background-color: #fff3cd;
    }
  }

  .readonly-text {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    font-family: $aisea-font-family;
    font-size: 14px;
    color: $aisea-dark-gray;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;

    &.noData {
      align-items: center;
    }
  }

  .editor {
    width: 100%;
  }

  .textarea-input {
    min-height: 52px;
    width: 100%;
    padding: 0.6rem 0.75rem;
    font-family: $aisea-font-family;
    font-size: 14px;
    color: $aisea-dark-gray;
    border: 1px solid $aisea-mouse-gray;
    border-radius: 6px;
    resize: none;
    overflow-y: auto;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      border-color: $aisea-blue;
      box-shadow: 0 0 0 2px rgba(45, 156, 219, 0.1);
    }
  }
}
</style>
